import React from "react";
import styled from "styled-components";
import * as COLOURS from "../../enums/colours";
import * as SIZES from "../../enums/sizes";

const SocialShareBlock = () => (
  <SocialShareInner className="span-2">
    <SocialShareTitle>Share</SocialShareTitle>
    <SocialShareLinkedIn />
    <SocialShareTwitter />
    <SocialShareFacebook />
  </SocialShareInner>
);

const SocialShareLinkedIn = ({ link }) => {
  return (
    <Social>
      <a
        href="#linkedin"
        className="share-linkedin"
        style={{ display: "flex" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="wbdi sz--md"
          viewbox="0 0 34 34"
        >
          <use xlinkHref="/themes/custom/wbd/assets/svg/defs.svg#share-linkedin" />
        </svg>
      </a>
    </Social>
  );
};

const SocialShareTwitter = ({ link }) => {
  return (
    <Social>
      <a href="#twitter" className="share-twitter" style={{ display: "flex" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="wbdi sz--md"
          viewbox="0 0 34 34"
        >
          <use xlinkHref="/themes/custom/wbd/assets/svg/defs.svg#share-twitter" />
        </svg>
      </a>
    </Social>
  );
};

const SocialShareFacebook = ({ link }) => {
  return (
    <Social>
      <a
        href="#facebook"
        className="share-facebook"
        style={{ display: "flex" }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="wbdi sz--md">
          <use xlinkHref="/themes/custom/wbd/assets/svg/defs.svg#share-facebook" />
        </svg>
      </a>
    </Social>
  );
};

const SocialShareInner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 2rem;
  border: 1px solid ${COLOURS.midGrey};
  border-radius: 0.4rem;
  background-color: ${COLOURS.white};
  transition: width 0.25s ease;
`;

const SocialShareTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  font-size: ${SIZES.sizeSm};
  font-weight: 700;
`;

const Social = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0.15rem;
`;

export default SocialShareBlock;



// WEBPACK FOOTER //
// ./src/socialShareBlock/components/SocialShareBlock.js